import React from 'react';

export const Feedback = React.lazy(() =>
  import(/* webpackChunkName: "feedback" */ './Feedback').then(m => ({
    default: m.Feedback,
  })),
);
